import wrapRootElement from "./src/context/Apollo/wrap";

export const wrapPageElement = wrapRootElement;